/* global jQuery  */
void (function initializeIntlTelInputControls($, engageCore) {
	'use strict';

	engageCore.intlTelInputProperties = engageCore.intlTelInputProperties || [];

	const validInputRegex =
		/^(?:(?:\(?(?:00)([1-4]\d\d|[1-9]\d?)\)?)?[-. \\/]?)?((?:\(?\d{1,}\)?[-. \\/]?){0,})(?:[-. \\/]?x[-. \\/]?(\d+))?$/g;
	const characterReplaceRegex = /(?:[^\dx.()\s-]+)/g;

	/**
	 * @param {number} errorCode The error code
	 * @returns {string} The error message
	 */
	function getErrorMessage(errorCode) {
		const INVALID_COUNTRY_CODE = 1;
		const TOO_SHORT = 2;
		const TOO_LONG = 3;
		const NOT_A_NUMBER = 4;

		if (errorCode === INVALID_COUNTRY_CODE) {
			return (
				(engageCore.intlTelInputMessages &&
					engageCore.intlTelInputMessages.invalidCountryMessage) ||
				'You have not selected a country code for your phone number, or the code is not valid. Please select the appropriate country code from the drop down to continue.'
			);
		}

		if (errorCode === TOO_SHORT) {
			return (
				(engageCore.intlTelInputMessages &&
					engageCore.intlTelInputMessages.tooShortMessage) ||
				'The phone number provided is too short.'
			);
		}

		if (errorCode === TOO_LONG) {
			return (
				(engageCore.intlTelInputMessages &&
					engageCore.intlTelInputMessages.tooLongMessage) ||
				'The phone number provided is too long.'
			);
		}

		if (errorCode === NOT_A_NUMBER) {
			return (
				(engageCore.intlTelInputMessages &&
					engageCore.intlTelInputMessages.notANumberMessage) ||
				'The phone number provided is not a valid phone number.'
			);
		}

		return (
			(engageCore.intlTelInputMessages &&
				engageCore.intlTelInputMessages.errorMessage) ||
			'The phone number provided is not a valid phone number.'
		);
	}

	engageCore.validateIntlTelInput = function validateIntlTelInput(
		source,
		args
	) {
		const $source = $(source);
		const $formItem = $source.parents('.dnnFormItem');
		const $phone = $formItem.find('.engagecore-intltelinput');
		const $dialCodes = $formItem.find('.engagecore-dialcodes');

		if (
			$phone.length &&
			$dialCodes.length &&
			$phone.intlTelInput('getSelectedCountryData')
		) {
			$dialCodes.val($phone.intlTelInput('getSelectedCountryData').iso2);
		}

		if (
			!$phone.length ||
			!$dialCodes.length ||
			$dialCodes.val() === 'auto'
		) {
			$source.text(
				(engageCore.intlTelInputMessages &&
					engageCore.intlTelInputMessages.invalidCountryMessage) ||
					'You have not selected a country code for your phone number, or the code is not valid. Please select the appropriate country code from the drop down to continue.'
			);
			args.IsValid = false;
			return;
		}

		if ($phone.intlTelInput('isValidNumber')) {
			args.IsValid = true;
			return;
		}

		const errorCode = $phone.intlTelInput('getValidationError');
		const IS_POSSIBLE = 0;
		if (errorCode === IS_POSSIBLE) {
			// If the number is a possible number we want to return valid.
			args.IsValid = true;
			return;
		}

		const message = getErrorMessage(errorCode);
		$source.text(message);
		args.IsValid = false;
	};

	engageCore.initializeIntlTelInputControls = () => {
		$.each(engageCore.intlTelInputProperties, (_, propertyData) => {
			const $phone = $(`#${propertyData.phoneClientId}`);
			const $validator = $phone.siblings(
				'span.dnnFormMessage.dnnFormError'
			);
			const $dialCodes = $(`#${propertyData.countryDataClientId}`);
			const $wrapper = $phone.parents('.intl-tel-input__property');
			const selectedDialCode = $dialCodes.val();
			const countryData = $.fn.intlTelInput.getCountryData();
			const initialCountryMatches = selectedDialCode
				? $.grep(
						countryData,
						(data) =>
							data.iso2.toLowerCase() ===
							selectedDialCode.toLowerCase()
					)
				: [];
			const initialCountry =
				initialCountryMatches && initialCountryMatches.length === 1
					? initialCountryMatches[0].iso2
					: 'auto';

			$wrapper.removeClass('no-js');

			$phone.on('paste propertychange', (e) => {
				let val = $phone.val();
				if (
					e.type === 'paste' &&
					e.originalEvent.clipboardData.getData('text')
				) {
					val = e.originalEvent.clipboardData.getData('text');
				}

				return validInputRegex.test(val);
			});

			$phone.on('input', () =>
				$phone.val($phone.val().replace(characterReplaceRegex, ''))
			);

			$phone.intlTelInput({
				nationalMode: false,
				separateDialCode: true,
				initialCountry,
				preferredCountries: propertyData.preferredCountries || [],
				utilsScript: `/Resources/libraries/intl-tel-input/${propertyData.version}/js/utils.js`,
			});

			$phone.on('countrychange', (eventData, { iso2 }) => {
				$phone.val('');
				$dialCodes.val(iso2);

				if ($validator.length && window.ValidatorValidate) {
					window.ValidatorValidate($validator[0]); // eslint-disable-line new-cap
				}

				$validator.css('visibility', 'hidden');
				$validator.text('');
				$phone.removeClass('validate-success');
				$phone.removeClass('validate-fail');
			});

			$dialCodes.hide();
		});
	};

	$(() => engageCore.initializeIntlTelInputControls());
})(jQuery, (window.engageCore = window.engageCore || {}));
